module.exports = __webpack_public_path__ + "static/kacper-wisiorowski-medinvest-31e26383b07d8de1912a034c1000e343.jpg";